/* eslint-disable max-statements */
import { graphql } from "./wp.api.service";
import { isArray } from "underscore";
import { useAuth } from "./wp.auth.service";

export const hasRole = (role, user) => {
	if (!user) {
		user = useAuth()?.user; /* eslint-disable-line no-param-reassign */
	}

	if (!user || !user.roles) {
		return false;
	}

	if (typeof role === "string") {
		if (role === "facilitator" && user.facilitatorId) {
			return true;
		}
		return user.roles.indexOf(role) !== -1; /* eslint-disable-line no-magic-numbers */
	} else if (isArray(role)) {
		for (const idx in role) {
			if (user.roles.indexOf(role[idx]) !== -1) {
				return true;
			}
		}
	}
	return false;
};

const query = `
	mutation UpdateUser($input: UpdateUserInput = {id: ""}) {
		updateUser(input: $input) {
			user {
				firstName
				lastName
			}
		}
	}
`;

export const updateUserMutation = (useMutation, options) => useMutation(
	"updateUser",
	(input) => graphql({
		query,
		variables: { input }
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}
			return { data };
		}),
	{
		...options
	}
);
